import { Location } from '@angular/common';

/**
 * HFBD-10: opens a representatie's access copy in the existing full-page viewer, in a new tab. Shared by every
 * place that offers a quick preview — the hierarchy row's `⋯` menu and the `Formaten` column's eye icon alike —
 * so the two stay one behaviour rather than drifting into two slightly different ways of opening the same URL.
 */
export function openRecordPreview(location: Location, recordId: string): void {
    window.open(location.prepareExternalUrl(`viewer/${recordId}`));
}
